import NavigationLinks from './NavigationLinks';

export default NavigationLinks;
